// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.z0LQYWnevYMWIU {
  margin: var(--ds-space-050, 4px) var(--ds-space-0, 0);
  padding: var(--ds-space-025, 2px) var(--ds-space-100, 8px);
  border-radius: 20px;
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
  color: var(--accent-text, var(--ds-text-subtle, #44546f));
  font-size: 12px;
  font-weight: var(--ds-font-weight-regular, normal);
  line-height: 20px;
  /* stylelint-disable plugin/no-unused-selectors */
  /* stylelint-enable plugin/no-unused-selectors */
}
.hhzs7jPSMKPxTK {
  background-color: var(--ds-background-accent-green-subtle, #4bce97);
  color: var(--accent-text-bolder, inherit);
}
.oct4u4U56BbGWu {
  background-color: var(--ds-background-accent-yellow-subtle, #f5cd47);
  color: var(--accent-text-bolder, inherit);
}
.BFQ_QKYguZ2wi5 {
  background-color: var(--ds-background-accent-orange-subtle, #fea362);
  color: var(--accent-text-bolder, inherit);
}
.uITO2Y5RO3ESNT {
  background-color: var(--ds-background-accent-red-subtle, #f87168);
  color: var(--accent-text-bolder, inherit);
}
.z3df2LnMz8TX74 {
  background-color: var(--ds-background-accent-purple-subtle, #9f8fef);
  color: var(--accent-text-bolder, inherit);
}
.k5mCI76HkIDyw2 {
  background-color: var(--ds-background-accent-blue-subtle, #579dff);
  color: var(--accent-text-bolder, inherit);
}
.eF7kIhQKLFWchn {
  background-color: var(--ds-background-accent-teal-subtle, #6cc3e0);
  color: var(--accent-text-bolder, inherit);
}
.g2sbmhP6HFx_yG {
  background-color: var(--ds-background-accent-lime-subtle, #94c748);
  color: var(--accent-text-bolder, inherit);
}
.UT8uekT1LIMEP8 {
  background-color: var(--ds-background-accent-magenta-subtle, #e774bb);
  color: var(--accent-text-bolder, inherit);
}
.am2rC2d3LxNmg2 {
  background-color: var(--ds-background-warning-bold, #e2b203);
  color: var(--ds-text-warning-inverse, #172b4d);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `z0LQYWnevYMWIU`,
	"badge--green": `hhzs7jPSMKPxTK`,
	"badge--yellow": `oct4u4U56BbGWu`,
	"badge--orange": `BFQ_QKYguZ2wi5`,
	"badge--red": `uITO2Y5RO3ESNT`,
	"badge--purple": `z3df2LnMz8TX74`,
	"badge--blue": `k5mCI76HkIDyw2`,
	"badge--teal": `eF7kIhQKLFWchn`,
	"badge--lime": `g2sbmhP6HFx_yG`,
	"badge--magenta": `UT8uekT1LIMEP8`,
	"badge--warning": `am2rC2d3LxNmg2`
};
export default ___CSS_LOADER_EXPORT___;
